import React, { useEffect, useRef, useState } from "react";
import "./MdSection.css";

function MdSection() {
  const sectionRef = useRef(null);
  const hasAnimated = useRef(false);
  const typingIntervalRef = useRef(null);

  const fullText =
    "Techno India Group is a dynamic organization whose primary focus is education. As a group, we sincerely believe that India’s comparative advantage in the global economy lies in education. India’s assimilation with the globalization process has challenged TIG to offer programmes that are in tune with the changing needs of the day. We have tried to meet that challenge.";

  const [displayText, setDisplayText] = useState("");

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated.current) {
            hasAnimated.current = true;

            let index = 0;

            typingIntervalRef.current = setInterval(() => {
              setDisplayText(fullText.slice(0, index + 1));
              index += 1;

              if (index >= fullText.length) {
                clearInterval(typingIntervalRef.current);
              }
            }, 25);
          }
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(section);

    return () => {
      observer.disconnect();
      if (typingIntervalRef.current) {
        clearInterval(typingIntervalRef.current);
      }
    };
  }, [fullText]);

  return (
    <div className="md-container" ref={sectionRef}>
      <div className="md-left-section">
        <img
          src="images/md-img.png"
          alt="Mr. Satyam Roychowdhury"
          className="md-profile-image"
        />
      </div>

      <div className="md-right-section">
        <div className="md-quote-box">
          <h4 className="md-title">From MD&apos;s Desk</h4>

          <div className="quote-wrap">
            <p className="quote quote-reserve">{fullText}</p>
            <p className="quote quote-typing">
              {displayText}
              <span className="typing-cursor" />
            </p>
          </div>

          <div className="arrow-iconsmd">
            <img src="images/profile-down-arrow.png" alt="Profile arrow" />
          </div>

          <div className="md-info">
            <p className="author">
              Mr. Satyam Roychowdhury
              <br />
              <span>Managing Director, Techno India Group</span>
            </p>

            <a className="learn-moremd" href="#">
              <i className="bi bi-arrow-right-circle-fill titile-learn-more-icon" />
              Learn more about Mr Satyam Roychowdhury
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MdSection;